<template>
    <div class="w-screen h-screen bg-gradient-to-b from-purple-100 to-purple-200 fixed top-0 left-0 -z-10"> </div>

    <div class="container mx-auto px-12 text-center">
        <app-logo class="w-screen lg:max-w-lg mx-auto mt-40 lg:mt-60" theme="light"></app-logo>

        <h1 class="text-white mt-20 text-2xl font-bold lg:text-4xl lg:px-44 xl:px-96">
            Genuine reviews to help you find the best tyres for your car
        </h1>

        <h3 class="text-white mt-20">
            Coming to the UK soon...
        </h3>

        <div class="text-grey-100 text-center mb-12 mt-40">
            &copy; {{ currentYear }}
        </div>
    </div>

    <div class="fixed bottom-0 w-screen -z-10 h-2/4">
        <div class="bg-tyres absolute bottom-0 right-0 w-screen h-full bg-contain bg-no-repeat bg-right-bottom max-w-[75%] -z-10"> </div>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import AppLogo from '@/Components/AppLogo.vue';

export default {
    components: {
        AppLogo
    },
    layout: null,
    computed: {
        currentYear() {
            return dayjs().format("YYYY");
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
